import React, { useContext } from 'react';
import { Axis } from '@prisjakt/ui';
import { Hideable } from '@prisjakt/ui/hideable';
import RouteContext from 'src/routes/context';
import { ActiveFilters } from './components/active-filter/active-filters';
import { PriceListFilterContext } from 'src/areas/product/price-list-filter-context';
import { IFilterState } from 'src/areas/product/types';
import { useEffectOnMount } from 'src/hooks/useEffectOnMount';
import { ViewportContext } from 'src/components/viewport';
import { AllFilters } from './components/all-filters';
import { getFiltersFromUserSettings } from './utils';
import { FiltersModal } from './components/filters-modal';
import { IOfferlistFilters } from './types';
import { FilterPanelWrapper } from './styles';

export const OfferlistFilters: React.FC<IOfferlistFilters> = props => {
  const {
    visible,
    closeHandler,
    variantGroups,
    conditions,
    categoryId,
  } = props;
  const { isMobile } = useContext(ViewportContext);
  const { dispatch: routeDispatch } = useContext(RouteContext);
  const { filters, reload } = useContext(PriceListFilterContext);
  const setProductTypeFiltersFromUserSettings = (
    storedFilters: IFilterState
  ) => {
    if (JSON.stringify(storedFilters) !== JSON.stringify(filters)) {
      // Using default values for variants and conditions
      reload(storedFilters, routeDispatch, null, 'new');
    }
  };

  useEffectOnMount(() => {
    const storedFilters = getFiltersFromUserSettings(filters);
    setProductTypeFiltersFromUserSettings(storedFilters);
  });

  return (
    <>
      <ActiveFilters />

      {isMobile && visible && (
        <FiltersModal
          conditions={conditions}
          variantGroups={variantGroups}
          categoryId={categoryId}
          closeHandler={closeHandler}
        />
      )}
      {!isMobile && (
        <Hideable visible={visible} collapse={Axis.Y}>
          <FilterPanelWrapper>
            <AllFilters
              conditions={conditions}
              variantGroups={variantGroups}
              categoryId={categoryId}
            />
          </FilterPanelWrapper>
        </Hideable>
      )}
    </>
  );
};
